import { render, staticRenderFns } from "./ActionsMenuInbox.vue?vue&type=template&id=76f1d034"
import script from "./ActionsMenuInbox.vue?vue&type=script&lang=js"
export * from "./ActionsMenuInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports